import { trpc } from 'trpc';

export const useCommunicationAlerts = (patientId?: string) => {
  const { data, isLoading } = trpc.context.communication.conversation.getAllAlerts.useQuery({
    patient: patientId,
  });

  return {
    data,
    isLoading,
  };
};
